import { render, staticRenderFns } from "./DiscussionCommentFilter.vue?vue&type=template&id=cc215346&"
import script from "./DiscussionCommentFilter.vue?vue&type=script&lang=js&"
export * from "./DiscussionCommentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports